<template>
  <div>
    <div v-for="(item, index) in internalValue" :key="index" class="mb-4">
      <v-row dense>
        <v-col cols="5.5">
          <v-text-field
            v-model="item.name"
            :label="$t('labels.name')"
            variant="outlined"
            density="compact"
            @input="emitUpdate"
            hide-details="auto"
            :disabled="!isOwner"
          />
        </v-col>

        <v-col cols="5.5">
          <v-text-field
            v-model="item.value"
            :label="$t('labels.value')"
            variant="outlined"
            density="compact"
            @input="emitUpdate"
            hide-details="auto"
            :disabled="!isOwner"
          />
        </v-col>

        <v-col cols="1" class="d-flex align-center justify-end">
          <v-icon
            @click="removeItem(index)"
            :disabled="!isOwner"
            class="cursor-pointer"
            >mdi-delete</v-icon
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  isOwner: Boolean,
});

const emit = defineEmits(["update:modelValue"]);

const internalValue = ref([]);

watch(
  () => props.modelValue,
  (val) => {
    internalValue.value = [...val];
  },
);

watch(
  () => internalValue.value,
  async (newVal /* , oldVal */) => {
    if (newVal?.length == 0) {
      emit("update:modelValue", [{ name: "", value: "" }]);
      return;
    }

    if (
      newVal[newVal.length - 1].name != "" &&
      newVal[newVal.length - 1].value != ""
    ) {
      internalValue.value.push({ name: "", value: "" });
      emit("update:modelValue", internalValue.value);
    }
  },
);

internalValue.value = [...props.modelValue];

function emitUpdate() {
  emit("update:modelValue", internalValue.value);
}

function removeItem(index) {
  internalValue.value.splice(index, 1);
  emitUpdate();
}
</script>
